/* global axios */
import ApiClient from './ApiClient';

class EmailCampaignAPI extends ApiClient {
  constructor() {
    super('talkvia_email_campaigns', { accountScoped: true });
  }

  get(page = 1) {
    return axios.get(this.url, { params: { page } });
  }

  show(id, page = 1) {
    return axios.get(`${this.url}/${id}`, { params: { page } });
  }

  preview(id) {
    return axios.get(`${this.url}/${id}/preview`);
  }

  dispatch(id) {
    return axios.post(`${this.url}/${id}/confirm`, { confirmed: 1 });
  }

  pause(id) {
    return axios.post(`${this.url}/${id}/pause`);
  }

  resume(id) {
    return axios.post(`${this.url}/${id}/resume`);
  }
}

export default new EmailCampaignAPI();
